import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Card, CardBody, CardTitle, Container } from "reactstrap";
//Import form component to render
import Loader from "../../components/Common/Loader";
import GlobalParamsForm from "../../components/Forms/GlobalParamsForm";
import { getTypeParams } from "../../store/actions";
//Import Breadcrumb
import "../Tables/datatables.scss";

class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      params: null,
      editable: false,
    };
  }
  componentDidMount() {
    this.props.getTypeParams(this.state.user, "global");
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetTypeParams === false &&
      prevProps.loadingGetTypeParams === true
    ) {
      console.log("Entra", this.props.typeParams);
      let params = this.props.typeParams;
      if (params) {
        this.setState({ params: params });
        console.log("PARAMS", params);
      }
    }
  }
  changeStatusFrom(event) {
    event.preventDefault();
    if (this.state.editable) {
      this.props.history.go();
    }
    this.setState({
      editable: !this.state.editable,
      params: this.state.params,
    });
  }
  render() {
    if (!this.state.params) {
      return (
        <React.Fragment>
          <div className="loaderCenter">
            <Loader></Loader>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            <Card>
              <CardBody>
                <CardTitle>
                  {this.state.editable ? (
                    <Button
                      className="btn btn-danger"
                      onClick={(event) => this.changeStatusFrom(event)}
                    >
                      {" "}
                      <i size="lg" className="mdi  mdi-cancel"></i>
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-secondary"
                      color="secondary"
                      onClick={(event) => this.changeStatusFrom(event)}
                    >
                      <i size="lg" className="mdi  mdi-pencil"></i>
                    </Button>
                  )}
                </CardTitle>
                <div className="mt-4 mb-4">
                  <CardTitle>{this.props.t("Parámetros Globales")}</CardTitle>
                </div>

                <GlobalParamsForm
                  params={this.state.params}
                  editable={this.state.editable}
                />
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { loadingGetTypeParams, typeParams } = state.GetTypeParams;
  return { loadingGetTypeParams, typeParams };
};
export default withRouter(
  connect(mapStateProps, { getTypeParams })(withNamespaces()(CreateUser))
);
